import { useEffect, useState } from "react";
import Confetti from "react-confetti";

// Show confetti for a limited time, then unmount
export default function ConfettiBurst({ active = false, duration = 5000, colors }) {
  const [size, setSize] = useState({ w: 0, h: 0 });
  const [running, setRunning] = useState(false);

  useEffect(() => {
    const onResize = () => setSize({ w: window.innerWidth, h: window.innerHeight });
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!active) return;
    setRunning(true);
    const id = setTimeout(() => setRunning(false), duration);
    return () => clearTimeout(id);
  }, [active, duration]);

  if (!running || !size.w) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-[60]">
      <Confetti
        width={size.w}
        height={size.h}
        numberOfPieces={280}
        recycle={false}
        gravity={0.25}
        colors={colors || ["#C5A880", "#D28E75", "#D9AEB0", "#9DB0A3", "#F5F2EB", "#3E3A35"]}
      />
    </div>
  );
}
